/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { orderConfirmationShippingInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationShippingInformation";
import {
    sharedAddressTitleStyle,
    sharedContentStyle,
} from "@monsma/App/WidgetExtensions/OrderApprovalDetails/OrderApprovalDetailsShippingInformationExtension";
import { css } from "styled-components";

orderConfirmationShippingInformationStyles.shippingInformationGridContainer = {
    gap: 20,
    css: css`
        flex-direction: column;
    `,
};

orderConfirmationShippingInformationStyles.shippingInformationTitleGridItem = {
    css: css`
        display: none !important;
    `,
};

orderConfirmationShippingInformationStyles.shippingOtherInformationGridItem = {
    css: css`
        display: none !important;
    `,
};
orderConfirmationShippingInformationStyles.shippingInformationGridContainer = {
    gap: 20,
    css: css`
        flex-direction: column;
        display: flex;
        height: 100%;
        > div {
            flex: 1;
        }
    `,
};

orderConfirmationShippingInformationStyles.shippingInformationAddressGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

orderConfirmationShippingInformationStyles.shippingAddressTitle = sharedAddressTitleStyle;

orderConfirmationShippingInformationStyles.shippingAddress = sharedContentStyle;
